// imports
import { Box, Typography } from '@mui/material';

// local imports
import { AdditionalLayer } from '../../../../../configs/additionalLayers';
import { LINK_BLUE } from '../../../../../constants/colors';

interface LayerSourceProps {
  layer: AdditionalLayer;
}

/**
 * LayerSource
 *
 * Renders the source information for a layer.
 * Displays a clickable link to the layer's data source using sourceName and sourceUrl.
 *
 * @param layer - The AdditionalLayer object
 * @returns {JSX.Element | null} The rendered source component or null if no sourceUrl or sourceName
 */
export default function LayerSource({ layer }: LayerSourceProps) {
  // Only render if layer has both sourceUrl and sourceName
  if (!layer?.sourceUrl || !layer?.sourceName) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 1,
        p: 1,
        pl: 0,
      }}
      data-testid={`layer-source-${layer.id}`}
    >
      <Typography
        component="div"
        variant="caption"
        sx={{
          fontWeight: 'bold',
          textTransform: 'uppercase',
          color: '#555',
          letterSpacing: '0.05em',
          mb: -0.5,
        }}
      >
        Source
      </Typography>
      <a
        href={layer.sourceUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Data source: ${layer.sourceName}`}
        style={{
          textDecoration: 'underline',
          color: LINK_BLUE,
          fontSize: '1rem',
          wordBreak: 'break-word',
        }}
      >
        {layer.sourceName}
      </a>
    </Box>
  );
}
